export default __webpack_public_path__ + "static/media/Alien.f3dfa57c.mp3";